/*

    Global popup settings

    enabled_on (array)
        Url path, popup will show on each specified page

    timer (boolean|number)
        If specified popup will show after X amount of time, provide value in miliseconds

    scroll_percent (boolean|number)
        If specified popup will show after X scroll from the top of the page

    outisde_close (boolean)
        If true popup will close after click on outside background

 */
module.exports = function () {
    return {
        frontend_config: [
            {
                magazine: {
                    title: "Ontvang onze Ibiza tips",
                    subtitle: "Gratis alle nieuwe restaurants, verborgen plekjes en de beste stranden!",
                    image_title: "ONTVANG MAGAZINE",
                    enabled_on: [
                        "/services/*",
                        "/ibiza-informatie/beachclubs/*",
                        "/ibiza-informatie/clubs/*",
                        "/blog/*",
                        "/ibiza-informatie/markten/",
                        "/ibiza-informatie/gebieden/",
                        "/ibiza-informatie/waar-heen/",
                        "/ibiza-informatie/praktische-info/",
                        "/ibiza-informatie/ibiza-met-kinderen/",
                        "/supermarkten-op-ibiza/",
                        "/ibiza-informatie/golfen-op-ibiza/",
                        "/ibiza-informatie/organische-boerderij/"
                    ],
                    timer: 1500,
                    scroll_percent: false,
                    outside_close: true,
                    magazine_type: "generic"    // magazine types: generic, restaurant, beach
                }
            },
            {
                beachesMagazine: {
                    title: "Onze favoriete stranden",
                    subtitle: "Lekker hip of juist weg van de massa. Wij zijn locals en weten waar je moet zijn!",
                    image_title: "STRANDEN MAGAZINE",
                    enabled_on: [
                        "/ibiza-informatie/stranden/*",
                    ],
                    timer: 1500,
                    scroll_percent: false,
                    outside_close: true,
                    magazine_type: "beach"    // magazine types: generic, restaurant, beach
                }
            },
            {
                restaurantsMagazine: {
                    title: "Wat zijn onze favoriete restaurants?",
                    subtitle: "Van ultieme luxe naar knusse verbogen plekjes. Wij zijn locals en geven jou al onze tips!",
                    image_title: "RESTAURANTS MAGAZINE",
                    enabled_on: [
                        "/ibiza-informatie/restaurants/*",
                    ],
                    timer: 1500,
                    scroll_percent: false,
                    outside_close: true,
                    magazine_type: "restaurant"    // magazine types: generic, restaurant, beach
                }
            }
        ],
    }
};